import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AddNews from 'features/AddNews';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from '@material-ui/core';
import Skeleton from 'components/Skeleton';
import useNewsList from 'customHooks/useNewsList';
import Pagination from '@material-ui/lab/Pagination';
import images from 'images/images.jfif';
import { MdModeEdit, MdDelete } from 'react-icons/md';
import { showPopup } from 'components/ConfirmPopup/popupSlice';
import Popup from 'components/ConfirmPopup';
import { imgBaseURL } from '../../apis/Admin';
import { IoIosArrowBack } from 'react-icons/io';
import { showLoader } from 'utils';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 1000,
  },
  container: {
    margin: '1rem',
  },
  filter: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '1rem',
  },
  pagination: {
    marginLeft: 'auto',
    margincenter: 'auto',
    marginBottom: '60px',
  },
  imgWidth: {
    width: '50px',
  },
  center: {
    textAlign: 'center',
  },
  start: {
    textAlign: 'start',
  },
  end: {
    textAlign: 'end',
  },
  pointer: {
    cursor: 'pointer',
  },
  backBtn: {
    background: '#c6c6c6',
    fontFamily: 'sans-serif !important',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#858685',
      color: 'white',
    },
  },
  btn: {
    background: '#45b77c',
    fontFamily: 'sans-serif !important',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#358c5e',
    },
  },
});

export default function News() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [currentId, setCurrentId] = useState('');
  const [editData, setEditData] = useState('');
  const [callStart, setCallStart] = useState(0);
  const [page, setPage] = React.useState(1);
  const newsUserList = useNewsList(callStart, 10);
  const [showNews, setShowNews] = useState(true);
  const loading = useSelector(state => state.news.loading);
  const totalUsers = useSelector(state => state.news.totalList);
  const [showAddNews, setShowAddNews] = useState(false);
  const [showAddBtn, setShowAddBtn] = useState(true);
  const [showNewsBtn, setShowNewsBtn] = useState(false);
  const [showEditBtn, setShowEditImg] = useState(true);

  const imgUrl = imgBaseURL;

  const popupDisplay = useSelector(state => state.popup.visibility);

  const totalPages_pre = totalUsers / 10;
  const totalUserPages =
    totalUsers % 10 === 0 ? totalPages_pre : Math.trunc(totalPages_pre) + 1;
  console.log(loading, 'newsUserList');

  useEffect(() => {
    setCallStart((page - 1) * 10);
  }, [page]);

  const handlePageChange = (value) => {
    setPage(value);
  };

  const pageFunc = () => {
    if (totalUserPages) {
      return totalUserPages;
    }
    return 0;
  };
  const addNews = () => {
    setShowAddNews(true);
    setShowNews(false);
    setShowAddBtn(false);
    setShowNewsBtn(true);
    setShowEditImg(false);
  };
  const news = () => {
    setShowAddNews(false);
    setShowNews(true);
    setShowAddBtn(true);
    setShowNewsBtn(false);
    setCurrentId('');
  };

  const handleDelete = id => {
    dispatch(showPopup({ visibility: true, id }));
  };

  const handleEdit = id => {
    setCurrentId(id);
    const currentData = newsUserList.find(newsData => newsData._id === id);
    setEditData(currentData);
    addNews();
    setShowEditImg(true);
  };
  const getBackBtn = val => {
    if (val) {
      return (
        <Grid item xs={6} className={classes.start}>
          <Button variant="contained" className={classes.backBtn} onClick={news}>
            <IoIosArrowBack size={20} /> <span>Back</span>
          </Button>
        </Grid>
      );
    }
  };
  console.log(currentId, 'currentId');
  console.log(editData, 'editData');
  const loginType = localStorage.getItem('loginType');
  return (
    <Skeleton>
      <div className={classes.root}>
        <Grid container spacing={3}>
          {getBackBtn(showNewsBtn)}
          {showAddBtn && (
            <Grid item xs={12} className={classes.end}>
              <Button variant="contained" color="primary" className={classes.btn} onClick={addNews}>
                Add News
              </Button>
            </Grid>
          )}
          {showNews && (
            <>
              <Grid item xs={12}>
                <TableContainer component={Paper} className={classes.container}>
                  <Table aria-label="simple table" className={classes.table}>
                    <TableHead className={classes.tabelHeaderBackground}>
                      <TableRow>
                        <TableCell
                          className={classes.tabelHeaderColor}
                          align="center"
                        >
                          Image
                        </TableCell>
                        <TableCell
                          className={classes.tabelHeaderColor}
                          align="center"
                        >
                          Title
                        </TableCell>
                        <TableCell
                          className={classes.tabelHeaderColor}
                          align="center"
                        >
                          Description
                        </TableCell>
                        <TableCell
                          className={classes.tabelHeaderColor}
                          align="center"
                        >
                          Status
                        </TableCell>
                        {parseInt(loginType) === 1 && (
                          <TableCell
                            className={classes.tabelHeaderColor}
                            align="center"
                          >
                            User
                          </TableCell>
                        )}
                        <TableCell
                          className={classes.tabelHeaderColor}
                          align="center"
                        >
                          Edit
                        </TableCell>
                        <TableCell
                          className={classes.tabelHeaderColor}
                          align="center"
                        >
                          Delete
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {newsUserList.map(newsInfo => (
                        <TableRow key={newsInfo._id} className={classes.center}>
                          <TableCell align="center">
                            <img
                              src={
                                newsInfo.image
                                  ? `${imgUrl}/${newsInfo.image}`
                                  : images
                              }
                              alt="news"
                              className={classes.imgWidth}
                            />
                          </TableCell>
                          <TableCell align="center">{newsInfo.title}</TableCell>
                          <TableCell align="center">
                            {newsInfo.description}
                          </TableCell>
                          <TableCell align="center">
                            {newsInfo.verifyStatus}
                          </TableCell>
                          {parseInt(loginType) === 1 && (
                            <TableCell align="center">
                              {newsInfo.user?.userName}
                            </TableCell>
                          )}
                          <TableCell align="center">
                            <MdModeEdit
                              size={25}
                              className={classes.pointer}
                              onClick={() => handleEdit(newsInfo._id)}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <MdDelete
                              size={25}
                              className={classes.pointer}
                              onClick={() => handleDelete(newsInfo._id)}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <div style={{ textAlign: 'center' }}>
                    {newsUserList.length === 0 && 'No Data'}
                  </div>
                </TableContainer>
                <div className={classes.pagination}>
                  <Pagination
                    color="primary"
                    count={pageFunc()}
                    page={page}
                    onChange={handlePageChange}
                  />
                </div>
              </Grid>
            </>
          )}
          {showAddNews && (
            <Grid item xs={12}>
              <AddNews
                currentId={currentId}
                editData={editData}
                showEditBtn={showEditBtn}
                setShowEditImg={setShowEditImg}
              />
            </Grid>
          )}
        </Grid>
      </div>
      {popupDisplay ? <Popup parent="news" /> : false}
      {showLoader(loading)}
    </Skeleton>
  );
}
